import { css } from 'styled-components'
import transformProps from '../utils/transformProps'
import { ConfigType, Dictionary, StyleType } from '../utils/transformProps/types'

export type SpacingKeys =
    | 'margin'
    | 'marginTop'
    | 'marginBottom'
    | 'marginRight'
    | 'marginLeft'
    | 'marginX'
    | 'marginY'
    | 'padding'
    | 'paddingTop'
    | 'paddingBottom'
    | 'paddingRight'
    | 'paddingLeft'
    | 'paddingX'
    | 'paddingY'

export type SpacingProps = {
    [key in SpacingKeys]?: Dictionary
}

export const spacingConfig: ConfigType<SpacingKeys> = {
    margin: {
        property: ['margin'],
        scale: 'space',
    },
    marginTop: {
        property: ['marginTop'],
        scale: 'space',
    },
    marginBottom: {
        property: ['marginBottom'],
        scale: 'space',
    },
    marginRight: {
        property: ['marginRight'],
        scale: 'space',
    },
    marginLeft: {
        property: ['marginLeft'],
        scale: 'space',
    },
    marginX: {
        property: ['marginLeft', 'marginRight'],
        scale: 'space',
    },
    marginY: {
        property: ['marginTop', 'marginBottom'],
        scale: 'space',
    },
    padding: {
        property: ['padding'],
        scale: 'space',
    },
    paddingTop: {
        property: ['paddingTop'],
        scale: 'space',
    },
    paddingBottom: {
        property: ['paddingBottom'],
        scale: 'space',
    },
    paddingRight: {
        property: ['paddingRight'],
        scale: 'space',
    },
    paddingLeft: {
        property: ['paddingLeft'],
        scale: 'space',
    },
    paddingX: {
        property: ['paddingLeft', 'paddingRight'],
        scale: 'space',
    },
    paddingY: {
        property: ['paddingTop', 'paddingBottom'],
        scale: 'space',
    },
}

export const space = css<SpacingProps>`
    ${(props): StyleType => transformProps(spacingConfig, props)}
`
